import Modal from 'react-modal';
import styled from 'styled-components';
import Button from 'components/Button';
import { customStyles } from 'utils/modalSettings';
import useModal from 'utils/useModal';

const ModalDiscardChanges = () => {
  const [isOpen, closeModalHandler] = useModal('discardChanges');

  return (
    <Modal
      style={customStyles}
      isOpen={isOpen}
      onRequestClose={() => closeModalHandler(false)}
    >
      <Wrapper>
        <Logo />
        <Title>Do you want to discard Lizzy's response?</Title>
        <Button
          size='small'
          width='long'
          styleType='secondary'
          onClick={() => closeModalHandler(true)}
        >
          Discard
        </Button>
        <Button
          size='small'
          width='long'
          styleType='disabled'
          onClick={() => closeModalHandler(false)}
        >
          Cancel
        </Button>
      </Wrapper>
    </Modal>
  );
}

export default ModalDiscardChanges;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;

  ${Button} {
    &:not(:last-child) {
      margin-bottom: 12px;
    }
  }
`;

const Title = styled.h3`
  all: unset;
  color: var(--lizzy-black);
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 11px;
  max-width: 70%;
  text-align: center;
`

const Logo = styled.div`
  width: 27px;
  height: 37px;
  background-image: url(${process.env.PUBLIC_URL}/assets/logo-middle.svg);
  margin-bottom: 11px;
`;